import { type QueryClient, queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/lib/api/common/items';
import type { ItemFiltersType } from '@/lib/api/types/itemFilters';
import type { ItemOrder } from '@/lib/api/types/items';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const invalidateItemsDataSet = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: commonQueryKeys.itemsDataSet.all() });
};

export const itemsDataSetQueryOptions = ({
  order,
  filter,
}: {
  order?: ItemOrder;
  filter?: ItemFiltersType;
}) => {
  return queryOptions({
    queryKey: [...commonQueryKeys.itemsDataSet.byFilter(filter), order],
    queryFn: () => ItemsApi.getItemsDataSet({ filter, order }),
  });
};

export const useItemsDataSetSuspenseQuery = ({ filter }: { filter?: ItemFiltersType } = {}) => {
  return useSuspenseQuery(itemsDataSetQueryOptions({ filter }));
};

export const useItemsDataSetQuery = ({ filter }: { filter?: ItemFiltersType } = {}) =>
  useQuery(itemsDataSetQueryOptions({ filter }));

export const useItemsTreeSetQuery = ({ filter }: { filter?: ItemFiltersType } = {}) =>
  useQuery({
    queryKey: commonQueryKeys.itemsTreeSet.byFilter(filter),
    queryFn: () => ItemsApi.getItemsTreeSet({ filter }),
  });
